import { prop, mergeRight } from 'ramda';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Loader, loadTexts } from '@twnel/web-components';
import { init, updateUser, installSetup } from './data/actions';
import configureStore from './configureStore';
import registerServiceWorker from './registerServiceWorker';
import makeApp from './ui';

// Set window size if installed.
if (
  window.matchMedia('(display-mode: standalone)').matches
  || window.navigator.standalone === true
) {
  window.resizeTo(Math.round(790 / 1.6180), 790);
}

// Store set up
const store = configureStore();
store.dispatch(init());

// Main app
const loader = Loader(store);
const App = makeApp({ loader });

// Initial render.
const app = React.createElement(App);
createRoot(document.getElementById('react')).render(
  React.createElement(Provider, { store }, app),
);

// Load the texts file.
store.dispatch(loadTexts(async (locale) => {
  let loaders;
  switch (locale) {
    case 'es':
      loaders = [
        import(/* webpackChunkName: "esLocale" */ '@twnel/web-components/lib/es.json'),
        import(/* webpackChunkName: "esLocale" */ 'resources/localization/es.json'),
      ];
      break;
    case 'pt':
      loaders = [
        import(/* webpackChunkName: "ptLocale" */ '@twnel/web-components/lib/pt.json'),
        import(/* webpackChunkName: "ptLocale" */ 'resources/localization/pt.json'),
      ];
      break;
    default:
      return {};
  }
  const result = await Promise.all(loaders);
  return result.map(prop('default')).reduce(mergeRight);
}));

// Register service worker.
registerServiceWorker(store);

// Install prompt.
window.addEventListener('beforeinstallprompt', (event) => {
  const install = () => {
    event.prompt();
    return event.userChoice;
  };
  store.dispatch((dispatch, getState, getContext) => {
    const { updateContext } = getContext();
    updateContext({ install });
    store.dispatch(updateUser({ installed: false }));
  });
});
window.addEventListener('appinstalled', () => {
  store.dispatch(installSetup());
});
